export const SET_NETWORKSTATE = "SET_NETWORKSTATE";